// extracted by mini-css-extract-plugin
export default {"menu-view__title":"r_bt my-2 p-2","menu-view__tile-row":"r_bv d-flex"};